@if (isLoading()) {
} @else if (profile()) {
	<div class="flex flex-col min-h-screen">

		<!-- ══ BANNIÈRE ══════════════════════════════════════════════════ -->
		<div class="relative h-[220px] md:h-[320px] lg:h-[400px] overflow-hidden shrink-0 bg-peps-dark-900">

			<!-- Image de bannière (base) -->
			<img src="/assets/images/banner.jpg" alt=""
			     class="absolute inset-0 w-full h-full object-cover">

			<!-- Dégradé bas pour ancrer l'en-tête -->
			<div class="absolute inset-x-0 bottom-0 h-40 pointer-events-none"
			     style="background: linear-gradient(180deg, transparent 0%, rgba(19,20,21,0.85) 100%);">
			</div>

			<!-- Trait or en bas -->
			<div class="absolute bottom-0 left-0 right-0 h-px pointer-events-none"
			     style="background: linear-gradient(90deg, transparent 0%, rgba(238,201,50,0.5) 30%, rgba(238,201,50,0.5) 70%, transparent 100%);">
			</div>

		</div>

		<!-- ══ CORPS : DASHBOARD 2 COLONNES ═════════════════════════════ -->
		<div class="px-6 md:px-10 lg:px-16 xl:px-20 pb-20 flex flex-col lg:flex-row gap-10 lg:gap-14 xl:gap-20">

			<!-- ────────────── COLONNE LATÉRALE ────────────── -->
			<aside class="w-full lg:w-[320px] xl:w-[380px] shrink-0 flex flex-col gap-10 lg:sticky lg:top-6 self-start">

				<!-- Avatar + identité -->
				<div class="flex flex-col items-center lg:items-start gap-5 -mt-16 md:-mt-24">

					<div class="shrink-0 relative z-10">
						@if (profile()!.picture) {
							<div class="w-fit rounded-full p-[4px]"
								style="background: linear-gradient(135deg, #EEC932 0%, #fdf7bd 40%, rgba(238,201,50,0.35) 70%, #EEC932 100%); box-shadow: 0 0 36px rgba(238,201,50,0.3), 0 0 10px rgba(238,201,50,0.18);">
								<div class="w-28 h-28 md:w-40 md:h-40 rounded-full overflow-hidden">
									<img [src]="profile()!.picture" [alt]="profile()!.username" class="w-full h-full object-cover">
								</div>
							</div>
						} @else {
							<div class="w-fit rounded-full p-[4px]"
								style="background: linear-gradient(135deg, #EEC932, rgba(238,201,50,0.3));">
								<div class="w-28 h-28 md:w-40 md:h-40 rounded-full bg-peps-dark-600 flex items-center justify-center">
									<span class="text-6xl font-dinpro text-peps-gold/60 uppercase">
										{{ profile()!.username.charAt(0) }}
									</span>
								</div>
							</div>
						}
						@if (isRecentlyLive()) {
							<div class="absolute bottom-2 right-2 w-5 h-5 md:w-6 md:h-6 rounded-full bg-green-500 border-2 border-peps-dark-900"
								[pepsTooltip]="'page.public-profile.recently-live' | translate">
							</div>
						}
					</div>

					<div class="flex flex-col items-center lg:items-start gap-2 min-w-0 w-full">
						<span class="text-[11px] uppercase font-dinpro-medium text-peps-gold/60 tracking-[0.35em]">Team Peps</span>
						<h1 class="text-4xl md:text-5xl uppercase font-dinpro leading-none break-words max-w-full text-center lg:text-left"
							style="background: linear-gradient(90deg, #EEC932 0%, #fdf7bd 55%, #ffffff 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">
							{{ profile()!.username }}
						</h1>

						@if (profile()!.battlePepsRank; as battlePepsRank) {
							<div class="flex items-center gap-2 mt-1">
								<img [src]="rankIcon(battlePepsRank.rank.code)" [alt]="battlePepsRank.rank.label" class="w-7 h-7 object-contain">
								<span class="text-sm uppercase font-dinpro-medium text-peps-dark-200/80">{{ battlePepsRank.rank.label }}</span>
								<span class="text-xl font-dinpro text-peps-gold tabular-nums">{{ battlePepsRank.xpCurrent }}</span>
								<span class="text-xs uppercase text-peps-dark-200/50 font-dinpro-medium">XP</span>
							</div>
						}

						<div class="flex flex-col items-center lg:items-start gap-2 mt-3 w-full">
							<span class="flex items-center gap-1.5 text-xs uppercase tracking-wider px-2.5 py-1 border border-peps-dark-500 text-peps-dark-200/70 font-dinpro-medium">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3.5 shrink-0">
									<path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
								</svg>
								{{ 'page.public-profile.member-since' | translate }} {{ profile()!.memberSince | localizedDate:'MMM yyyy' }}
							</span>
						</div>
					</div>
				</div>

				<!-- Bloc stats KPI -->
				<div>
					<div class="flex items-center gap-3 mb-4">
						<span class="text-xs uppercase font-dinpro-medium text-peps-gold/50 tracking-[0.3em]">{{ 'page.public-profile.stats-title' | translate }}</span>
						<div class="flex-1 h-px bg-peps-dark-500"></div>
					</div>
					<div class="grid grid-cols-2 gap-3">
						@for (tile of statTiles(); track tile.labelKey) {
							<div class="border border-peps-dark-500 px-4 py-4 flex flex-col gap-1"
								style="background: linear-gradient(135deg, rgba(238,201,50,0.05) 0%, transparent 65%);">
								<span class="text-3xl md:text-4xl font-dinpro text-peps-gold tabular-nums leading-none">{{ tile.value }}</span>
								<span class="text-[11px] uppercase tracking-wider text-peps-dark-200/45 font-dinpro-medium leading-tight">{{ tile.labelKey | translate }}</span>
							</div>
						}
					</div>
				</div>

				<!-- Historique de rang BattlePeps -->
				@if (profile()!.rankHistory.length) {
					<div>
						<div class="flex items-center gap-3 mb-4">
							<span class="text-xs uppercase font-dinpro-medium text-peps-gold/50 tracking-[0.3em]">{{ 'page.public-profile.rank-history-title' | translate }}</span>
							<div class="flex-1 h-px bg-peps-dark-500"></div>
						</div>
						<div class="flex flex-col gap-2">
							@for (entry of profile()!.rankHistory; track entry.year) {
								<div class="flex items-center justify-between gap-2 bg-peps-dark-700 border border-peps-dark-500 px-4 py-2.5">
									<span class="text-xs uppercase text-peps-dark-200/40 tracking-wider shrink-0">{{ entry.seasonName }} {{ entry.year }}</span>
									@if (entry.rank) {
										<div class="flex items-center gap-2 min-w-0">
											<img [src]="rankIcon(entry.rank.code)" [alt]="entry.rank.label" class="w-5 h-5 object-contain shrink-0">
											<span class="text-sm font-dinpro-medium text-peps-dark-200/80 truncate">{{ entry.rank.label }}</span>
										</div>
									} @else {
										<span class="text-sm text-peps-dark-200/30 italic">{{ 'page.public-profile.no-rank' | translate }}</span>
									}
								</div>
							}
						</div>
					</div>
				}

				<!-- Badges -->
				@if (profile()!.badges.length) {
					<div>
						<div class="flex items-center gap-3 mb-4">
							<span class="text-xs uppercase font-dinpro-medium text-peps-gold/50 tracking-[0.3em]">{{ 'page.public-profile.badges-title' | translate }}</span>
							<div class="flex-1 h-px bg-peps-dark-500"></div>
						</div>
						<div class="flex flex-col gap-3">
							@for (badge of profile()!.badges; track badge.id) {
								<div class="border border-peps-dark-500 p-3.5 flex flex-row items-center gap-3 hover:border-peps-gold/30 transition-colors duration-200"
									style="background: linear-gradient(135deg, rgba(238,201,50,0.04) 0%, transparent 60%);">
									<div class="w-11 h-11 rounded-full border border-peps-gold/30 bg-peps-gold/5 flex items-center justify-center shrink-0">
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 text-peps-gold/60">
											<path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
										</svg>
									</div>
									<div class="flex flex-col items-start gap-0.5 min-w-0">
										<span class="text-sm font-dinpro uppercase text-peps-dark-200 leading-tight truncate w-full">{{ badge.translations[translateDynamicService.getLang()].name }}</span>
										<span class="text-xs font-notosans text-peps-dark-200/35 text-left">{{ badge.translations[translateDynamicService.getLang()].description }}</span>
									</div>
								</div>
							}
						</div>
					</div>
				}
			</aside>

			<!-- ────────────── COLONNE PRINCIPALE ────────────── -->
			<div class="flex-1 min-w-0 flex flex-col gap-14 pt-8 lg:pt-10">

				<!-- Comparatif face-à-face -->
				@if (compare(); as compare) {
					<section>
						<div class="flex items-center gap-4 mb-6">
							<span class="text-sm md:text-base uppercase font-dinpro-medium text-peps-gold/60 tracking-[0.3em]">{{ 'page.public-profile.compare-title' | translate }}</span>
							<div class="flex-1 h-px bg-peps-dark-500"></div>
						</div>
						<div class="grid grid-cols-3 gap-3 md:gap-6 w-full max-w-2xl text-center">
							<div class="flex flex-col gap-1">
								<span class="text-2xl md:text-3xl font-dinpro tabular-nums" [class.text-peps-gold]="compare.viewer.won >= compare.target.won">{{ compare.viewer.won }}</span>
								<span class="text-[11px] uppercase text-peps-dark-200/40 tracking-wider">{{ 'page.public-profile.compare-you' | translate }}</span>
							</div>
							<div class="flex flex-col gap-1 justify-center">
								<span class="text-xs md:text-sm uppercase text-peps-dark-200/50 font-dinpro-medium tracking-wider">{{ 'page.public-profile.compare-won' | translate }}</span>
							</div>
							<div class="flex flex-col gap-1">
								<span class="text-2xl md:text-3xl font-dinpro tabular-nums" [class.text-peps-gold]="compare.target.won > compare.viewer.won">{{ compare.target.won }}</span>
								<span class="text-[11px] uppercase text-peps-dark-200/40 tracking-wider truncate">{{ profile()!.username }}</span>
							</div>

							<span class="text-xl md:text-2xl font-dinpro tabular-nums text-peps-dark-200">{{ betWinRate(compare.viewer) }}%</span>
							<span class="text-xs md:text-sm uppercase text-peps-dark-200/50 font-dinpro-medium tracking-wider self-center">{{ 'page.public-profile.compare-winrate' | translate }}</span>
							<span class="text-xl md:text-2xl font-dinpro tabular-nums text-peps-dark-200">{{ betWinRate(compare.target) }}%</span>

							<span class="text-xl md:text-2xl font-dinpro tabular-nums text-peps-dark-200">{{ compare.viewer.perfects }}</span>
							<span class="text-xs md:text-sm uppercase text-peps-dark-200/50 font-dinpro-medium tracking-wider self-center">{{ 'page.public-profile.compare-perfects' | translate }}</span>
							<span class="text-xl md:text-2xl font-dinpro tabular-nums text-peps-dark-200">{{ compare.target.perfects }}</span>
						</div>
					</section>
				}

				<!-- Cartes favorites -->
				<section>
					<div class="flex items-center gap-4 mb-6">
						<span class="text-sm md:text-base uppercase font-dinpro-medium text-peps-gold/60 tracking-[0.3em]">{{ 'page.public-profile.favorites-title' | translate }}</span>
						<div class="flex-1 h-px bg-peps-dark-500"></div>
					</div>

					@if (profile()!.favoriteCards.length) {
						<div class="flex flex-row flex-wrap gap-12 justify-center md:justify-start">
							@for (favorite of profile()!.favoriteCards; track favorite.card.id) {
								<div style="width: 252px; height: 369px; position: relative; overflow: visible;">
									<div style="transform: scale(0.9); transform-origin: top left;">
										<app-card
											[rarity]="favorite.card.rarity"
											[name]="favorite.card.name"
											[score]="favorite.score"
											[rating]="favorite.card.rating"
											[image]="favorite.card.fileName"
											[extensionId]="favorite.card.extension.id"
											[author]="favorite.card.author"
										/>
									</div>
								</div>
							}
						</div>
					} @else {
						<div class="border border-peps-dark-500 border-dashed py-16 flex flex-col items-center gap-3">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="size-10 text-peps-dark-200/20">
								<path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
							</svg>
							<span class="text-xs uppercase font-dinpro-medium text-peps-dark-200/30 tracking-wider">{{ 'page.public-profile.no-favorites' | translate }}</span>
						</div>
					}
				</section>

				<!-- Cartes en vente -->
				<section>
					<div class="flex items-center gap-4 mb-6">
						<span class="text-sm md:text-base uppercase font-dinpro-medium text-peps-gold/60 tracking-[0.3em]">{{ 'page.public-profile.listings-title' | translate }}</span>
						<div class="flex-1 h-px bg-peps-dark-500"></div>
					</div>

					@if (listings().length) {
						<div class="flex flex-row flex-wrap gap-12 justify-center md:justify-start">
							@for (listing of listings(); track listing.id) {
								<div class="flex flex-col items-center gap-3">
									<div style="width: 252px; height: 369px; position: relative; overflow: visible;">
										<div style="transform: scale(0.9); transform-origin: top left;">
											<app-card
												[rarity]="listing.card.rarity"
												[name]="listing.card.name"
												[score]="listing.score"
												[rating]="listing.card.rating"
												[image]="listing.card.fileName"
												[extensionId]="listing.card.extension.id"
												[author]="listing.card.author"
											/>
										</div>
									</div>
									<div class="flex items-baseline gap-1">
										<span class="text-2xl font-dinpro-bold text-peps-gold leading-none">{{ listing.price }}</span>
										<span class="text-xs uppercase tracking-widest text-peps-gold/40 leading-none">PepsCoins</span>
									</div>
								</div>
							}
						</div>
					} @else {
						<div class="border border-peps-dark-500 border-dashed py-16 flex flex-col items-center gap-3">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="size-10 text-peps-dark-200/20">
								<path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
							</svg>
							<span class="text-xs uppercase font-dinpro-medium text-peps-dark-200/30 tracking-wider">{{ 'page.public-profile.no-listings' | translate }}</span>
						</div>
					}
				</section>

				<!-- Derniers pronostics -->
				<section class="flex-1">
					<div class="flex items-center gap-4 mb-6">
						<span class="text-sm md:text-base uppercase font-dinpro-medium text-peps-gold/60 tracking-[0.3em]">{{ 'page.public-profile.recent-predictions-title' | translate }}</span>
						<div class="flex-1 h-px bg-peps-dark-500"></div>
					</div>

					@if (profile()!.recentPredictions.length) {
						<div class="flex flex-col gap-2.5 w-full max-w-3xl">
							@for (prediction of profile()!.recentPredictions; track prediction.id) {
								<div class="flex items-center justify-between gap-4 bg-peps-dark-700 border border-peps-dark-500 px-5 py-4">
									<div class="flex flex-col gap-0.5 min-w-0">
										<span class="text-base font-dinpro-medium text-peps-dark-200 truncate">
											{{ prediction.matchup.team1.name }} vs {{ prediction.matchup.team2.name }}
										</span>
										<span class="text-xs text-peps-dark-200/45 font-notosans">
											{{ prediction.winner.name }} — {{ prediction.score }} · {{ prediction.createdAt | localizedDate:'d MMM yyyy' }}
										</span>
									</div>
									<span class="shrink-0 text-xs uppercase tracking-wider px-2.5 py-1 border font-dinpro-medium" [ngClass]="predictionStatusClass(prediction.status)">
										{{ predictionStatusKey(prediction.status) | translate }}
									</span>
								</div>
							}
						</div>
					} @else {
						<div class="border border-peps-dark-500 border-dashed py-10 flex flex-col items-center gap-3">
							<span class="text-xs uppercase font-dinpro-medium text-peps-dark-200/30 tracking-wider">{{ 'page.public-profile.no-predictions' | translate }}</span>
						</div>
					}
				</section>
			</div>
		</div>
	</div>
}
